module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Pour your eternal dreams, samples of blood")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("From one glass to another.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Osip Mandelstam (translated by James Greene)")]), _vm._v(" "), _c('p', {
    staticClass: "EP1"
  }, [_vm._v("The spider spins her web on dark days.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Proverb")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0